import { render, staticRenderFns } from "./LimitForm.vue?vue&type=template&id=1ed87326&"
import script from "./LimitForm.vue?vue&type=script&lang=ts&"
export * from "./LimitForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports